<template>
  <v-card flat class="pa-2">
    <v-card-title>افزودن استور شخصی</v-card-title>
    <v-card flat class="pa-2 w-100 d-flex flex-wrap align-items-center">
      <template v-for="(app, i) in computedValue">
        <v-tooltip :color="app?.color" :key="i" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-hover v-slot="{ hover }">
              <div
                @click="$emit('click', app, i)"
                style="cursor: pointer"
                v-bind="attrs"
                :style="{
                  background: app?.color ?? '',
                  opacity: hover && app?.color?.length > 0 ? '.8' : '1',
                }"
                v-on="on"
                class="qrBtn ma-2"
              >
                <v-img
                  v-if="app?.images?.length > 0"
                  :src="app?.images"
                  height="50"
                  width="50"
                />
              </div>
            </v-hover>
          </template>
          <span>{{ app?.title }}</span>
        </v-tooltip>
      </template>
      <template>
        <v-btn
          height="45"
          width="45"
          @click="dialog = true"
          small
          outlined
          color="green"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
    </v-card>

    <custom-popup
      :cons="cons"
      max-height="500"
      max-width="700"
      v-model="dialog"
    >
      <v-card falt style="overflow: hidden" class="pa-2">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              dense
              clearable
              outlined
              label="نام اپلیکیشن"
              placeholder="نام اپلیکیشن خود را به فارسی وارد کنید"
              v-model="newApp.title"
              hint="مثال:اپلیکیشن شخصی"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              dense
              clearable
              outlined
              label="شناسه اپلیکیشن"
              placeholder="شناسه اپلیکیشن خود را به انگلیسی وارد کنید"
              :rules="rules.english"
              v-model="newApp.name"
              hint="مثال:personalApp "
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              dense
              clearable
              outlined
              label="لیبل اپلیکیشن"
              placeholder="لیبل اپلیکیشن خود را وارد کنید"
              v-model="newApp.label"
              hint="مثال:اپلیکیشن شخصی "
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-card
              flat
              class="d-flex align-items-start justify-content-around"
            >
              <v-radio-group v-model="radios" class="pa-0 ma-0">
                <v-radio label="انتخاب عکس" value="picSelectorPopUp" />
                <v-radio label="انتخاب رنگ" value="colorPallete" />
              </v-radio-group>
              <v-btn @click="$data[radios] = true" outlined color="green">
                <v-icon>mdi-plus</v-icon>
                {{ radios == "picSelectorPopUp" ? "انتخاب عکس" : "انتخاب رنگ" }}
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </custom-popup>

    <custom-popup
      max-width="350"
      max-height="800"
      v-model="colorPallete"
      :cons="{ title: 'انتخاب رنگ' }"
    >
      <v-card style="overflow: hidden" flat class="pa-2">
        <color-pallete v-model="newApp.color" />
      </v-card>
    </custom-popup>

    <pic-selector-pop-up
      :field.sync="image"
      :edit-img="false"
      :edit-name="false"
      single
      one-pic
      :popup.sync="picSelectorPopUp"
      @change="getImage"
    />
  </v-card>
</template>

<script>
import picSelectorPopUp from "../../../../components/UploadCenter/voiceGallery/template/picSelectorPopUp.vue";
import colorPallete from "../../../../components/colorPallete.vue";

export default {
  components: { picSelectorPopUp, colorPallete },
  name: "customApplication",
  props: {
    value: [Array, Object],
    links: [Array, Object],
  },

  data() {
    return {
      cons: {
        title: "افزودن اپلیکیشن شخصی",
        buttons: [{ type: "submit", handler: () => this.addApplications() }],
      },
      image: "",
      persianRe: /^[\u0600-\u06FF\s]+$/,
      englishRe: /^(?=.*[A-Za-z])[A-Za-z0-9]+$/,
      rules: {
        persian: [
          (v) =>
            v == null ||
            /^[\u0600-\u06FF\s]+$/.test(v) ||
            "حروف وارده باید فارسی باشد",
        ],
        english: [
          (v) =>
            v == null ||
            /^(?=.*[A-Za-z])[A-Za-z0-9]+$/.test(v) ||
            "حروف وارده باید انگلیسی باشد",
        ],
      },
      dialog: false,
      picSelectorPopUp: false,
      colorPallete: false,
      newApp: {
        title: null,
        name: null,
        images: null,
        color: "",
        label: null,
        placeholder: null,
        height: "80",
        width: "80",
      },

      radios: "picSelectorPopUp",
    };
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    "newApp.color": {
      deep: true,
      handler(val) {
        if (val?.length > 0 && this.newApp?.images?.length > 0) {
          this.newApp.images = null;
          this.image = null;
        }
      },
    },
    computedValue: {
      deep: true,
      handler(val) {
        console.log(val);
      },
    },
  },

  methods: {
    getImage(e) {
      let image = e;
      this.newApp.images = image;
      this.newApp.color = null;
      this.picSelectorPopUp = false;
    },
    addApplications() {
      let tCh = this.newApp?.title?.length > 0;
      let nCh =
        this.newApp?.name?.length > 0 && this.englishRe.test(this.newApp?.name);

      let cVi =
        this.newApp?.images?.length > 0 || this.newApp?.color?.length > 0;

      let cUniq = !Object.hasOwn(this.links, this.newApp.name);

      if (tCh && nCh && cVi && cUniq) {
        this.computedValue.push(this.newApp);
        this.newApp = {
          title: null,
          name: null,
          images: null,
          color: "",
          label: null,
          placeholder: null,
          height: "80",
          width: "80",
        };
      } else {
        setTimeout(() => (this.dialog = true), 1200);
        if (!cUniq) {
          this.$toast.error("شناسه اپلیکیشن باید یکتا باشد");
          return;
        }
        if (!tCh || !nCh) {
          this.$toast.error("مقادیر وارد شده کامل یا صحیح نمیباشد");
          return;
        }
        if (!cVi) {
          this.$toast.error("اپلیکیشن نمیتواند فاقد رنگ یا عکس باشد");
          return;
        }
      }
    },
  },
};
</script>

<style scoped>
.qrBtn {
  border-radius: 15px !important;
  box-shadow: 4px 3px 5px rgba(2, 16, 92, 0.3);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  transition: all 0.15s ease-in-out;
}

.qrBtn:hover {
  border-radius: 8px !important;
  box-shadow: 8px 5px 10px #02105c8c !important;
}
</style>
